var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNoPrint(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#888888",
      stroke: "#000000",
      strokeWidth: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EBEBDA"
    },
    d: "M 19,44 19,3 81,3 81,44"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      strokeWidth: 2
    },
    d: "M 26 10 L 74 10 L 26 10 z M 26 17 L 74 17 L 26 17 z M 26 24 L 74 24 L 26 24 z M 26 31 L 46 31 L 26 31 z M 26 39 L 74 39 L 26 39 z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#444444"
    },
    d: "m 5,89 c 0,4 -1,7 4,7 0,0 79,0 82,0 3,0 4,-1 4,-7"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m 4,54 5,-10 81,0 6,10"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m 9,53 c -6,0 -7,1 -7,6 l 0,24 c 0,4 0,6 5,6 l 84,0 c 4,0 7,0 7,-5 l 0,-27 c 0,-2 -1,-4 -6,-4 z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#666666"
    },
    d: "m 14,57 c -4,0 -5,1 -5,5 0,2 -1,6 4,6 l 66,0 c 4,0 5,-1 5,-6 0,-4 -1,-5 -5,-5 z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 16,
    cy: 62.5,
    rx: 3,
    ry: 3,
    style: {
      fill: "#00BC02",
      stroke: "#111111"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF3D3D",
      fillOpacity: 0.7,
      stroke: "#730000",
      strokeWidth: 2
    },
    d: "M 49,43 40,52 58,70 40,88 49,97 67,79 84,97 93,88 76,70 94,51 85,43 68,61 z"
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoPrint);
export default __webpack_public_path__ + "static/media/no-print.3a1a11b730523d8b5350dca60c567c77.svg";
export { ForwardRef as ReactComponent };